import React, { useState } from 'react'
import classNames from "classnames";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { useForm } from '@inertiajs/inertia-react'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs';
import Layout from '../../Shared/Layout/LayoutAdmin';

const Edit = ({ item }) => {

    const { data, setData, post, processing, errors } = useForm({
        nombre: item.nombre || "",
        activo: item.activo,
    })

    function submit(e) {
        e.preventDefault()
        post(route('departments.update', item.id))
    }
    return (
        <Row>
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath="/admin/master_data/investment_fund_percentage/edit" />
            </span>
            <h2>Editar Departamento</h2>
            <Form onSubmit={submit}>
                <Form.Group className="mb-3" controlId="formAdd">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control type="text" className={classNames({
                        'is-invalid': (errors.nombre) ? true : false,
                    })}
                        value={data.nombre} onChange={(e) =>
                            setData("nombre", e.target.value)
                        } aria-invalid={errors.nombre ? "true" : "false"} />
                    {errors.nombre && <div className="mt-2 text-danger">{errors.nombre}</div>}
                </Form.Group>
                <Form.Group className="mb-3">
                        <Form.Label>Activo?</Form.Label>
                        <Form.Select defaultValue={data.activo}  onChange={e => setData('activo', e.target.value)}>
                            <option value="1">Sí</option>
                            <option value="0">No</option>
                        </Form.Select>
                        {errors.activo && <div className="mt-2 text-danger">{errors.activo}</div>}
                    </Form.Group>
                <Button variant="primary" className='me-3' disabled={processing} type="submit">Guardar</Button>
                <Button onClick={()=>window.history.back()} variant="secondary" type="normal">Regresar</Button>
            </Form>
        </Row>
    );
}

Edit.layout = page => <Layout children={page} title="Editar Departamento" />

export default Edit
